import { style } from '@vanilla-extract/css';

export const authorsContainer = style({
  display: 'flex',
  padding: 'var(--container-padding)',
  borderRadius: 'var(--container-border-radius)',
  borderWidth: 'var(--container-border-width)',
  borderColor: 'var(--container-border-color)',
  borderStyle: 'var(--container-border-style)',
  minWidth: '0px',
  width: '100%',
  overflowX: 'var(--container-overflow-x)',
  overflowY: 'var(--container-overflow-y)',
  gap: '1rem',
  position: 'relative',
  userSelect: 'none',
  boxSizing: 'content-box',
});

export const authorsInnerContainer = style({
  display: 'flex',
  flexDirection: 'var(--container-flex-direction)',
  gap: '1rem',
});

export const authorCard = style({
  borderRadius: 'var(--card-border-radius)',
  borderWidth: 'var(--card-border-width)',
  borderColor: 'var(--card-border-color)',
  borderStyle: 'var(--card-border-style)',
  padding: 'var(--card-padding)',
  backgroundColor: 'var(--card-background-color)',
});

export const authorBio = style({
  color: 'var(--bio-text-color)',
  fontFamily: 'var(--bio-font-family)',
  textAlign: 'var(--alignment)',
});

export const authorName = style({
  color: 'var(--name-text-color)',
  fontFamily: 'var(--name-font-family)',
  textAlign: 'var(--alignment)',
});

export const authorImage = style({
  width: '100%',
  height: '100%',
  flexGrow: 1,
  objectFit: 'cover',
});

export const socials = style({
  fill: 'var(--social-fill-color)',
});
